import { render, staticRenderFns } from "./LpPortfolioDetails.vue?vue&type=template&id=84320c04&scoped=true"
import script from "./LpPortfolioDetails.vue?vue&type=script&lang=js"
export * from "./LpPortfolioDetails.vue?vue&type=script&lang=js"
import style0 from "./LpPortfolioDetails.vue?vue&type=style&index=0&id=84320c04&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84320c04",
  null
  
)

export default component.exports